<template>
	<v-row>
		<v-col cols="12" md="6">
			Dudas o aclaraciones <br/>
			<v-icon left>phone</v-icon> {{ telefono }}<br/>
			<v-icon left>mdi-email </v-icon>{{email}}<br/>
			<v-btn text flat href="https://www.facebook.com/surtimedix" target="_blank"><v-icon left>mdi-facebook</v-icon>Surtimedix</v-btn>
		</v-col>
		<v-col cols="12" md="6">
			<v-row class="pa-0">
				<v-col cols="12" md="6" class="pa-0">
					<v-icon left>mdi-whatsapp </v-icon>Soporte 81 2105 8094 <br/>
					<v-icon left>mdi-email </v-icon>sofsolution.dev@gmail.com<br/>
					<v-icon left>person </v-icon>Eduardo Daniel Hernández Zavala<br/>
					<v-btn text flat href="https://sofsolution.com/" target="_blank"><v-icon left >mdi-earth</v-icon>Sofolution</v-btn>
				</v-col>
				<v-col cols="12" md="6">
					<v-card>
					  <v-img src="" contain/>
					</v-card>
				</v-col>
			</v-row>
		</v-col>
	</v-row>
</template>

<script>
	export default{
		data(){
			return{
				telefono:'',
				email:'',
				facebook:'',
			}
		},

		created(){
			this.getTelefono()
		},

		methods:{
			getTelefono(){
        this.$http.get('tienda/datosfiscales').then(response=>{
          console.log('telefono', response.body[0])
          this.telefono = response.body[0].telefono
          this.email = response.body[0].email
        }, error => {console.log(error)})

        this.$http.get('config.list').then(response=>{
          var ciaws = response.body
          this.facebook = ciaws.facebook
        }, error => {console.log(error)})

      },
		}
	}
</script>